import type { FlexibleConnectedPositionStrategyOrigin } from '@angular/cdk/overlay';
import { OverlayContainer, OverlayPositionBuilder, ViewportRuler } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { RtFlexibleConnectedPositionStrategy } from './rt-flexible-connected-position';

@Injectable({ providedIn: 'root' })
export class RtPositionBuilderService extends OverlayPositionBuilder {
  constructor(
    private viewportRuler: ViewportRuler,
    @Inject(DOCUMENT) private document: any,
    private platform: Platform,
    private overlayContainer: OverlayContainer,
  ) {
    super(viewportRuler, document, platform, overlayContainer);
  }

  public rtFlexibleConnectedTo(
    origin: FlexibleConnectedPositionStrategyOrigin,
  ): RtFlexibleConnectedPositionStrategy {
    return new RtFlexibleConnectedPositionStrategy(
      origin,
      this.viewportRuler,
      this.document,
      this.platform,
      this.overlayContainer,
    );
  }
}
